import { getAuthHeaders } from './api';

/**
 * `getAuthHeaders`, scoped to `officeId` when one is named. By default a request is scoped to the
 * store's selected office; a caller that acts for another office without switching to it — a
 * child picked inside the shift form (GOTU-14829), a location opened from Location Settings
 * (GOTU-19472) — names that office and gets its `x-office` instead.
 */
export const scopedHeaders = async (officeId?: string | null): Promise<Record<string, string>> => {
  const headers = await getAuthHeaders();
  return officeId ? { ...headers, 'x-office': officeId } : headers;
};
